import { render } from "./yjbg.vue?vue&type=template&id=20844179&scoped=true&ts=true"
import script from "./yjbg.vue?vue&type=script&lang=ts"
export * from "./yjbg.vue?vue&type=script&lang=ts"

import "./yjbg.vue?vue&type=style&index=0&id=20844179&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20844179"]])

export default __exports__